import { withUnmountTransition } from '../../../../misc/withUnmountTransition.hoc'
import { SearchMedicalEventDocumentsBottomPanel } from './SearchMedicalEventDocumentsBottomPanel.component'

const withUnmountHoc = withUnmountTransition(SearchMedicalEventDocumentsBottomPanel)
export { withUnmountHoc as SearchMedicalEventDocumentsBottomPanel }
